import React from "react";

const AboutPage = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6 md:px-12 py-10 bg-gray-100 text-gray-900">
      {/* Başlık */}
      <h1 className="text-3xl md:text-5xl font-bold text-center">Hakkımda</h1>

      {/* Açıklama */}
      <p >
        Merhaba! Ben [Adın], modern web teknolojileriyle çalışan bir yazılım geliştiricisiyim.
        React, TypeScript, Node.js ve daha birçok teknolojiyle projeler geliştiriyorum.
      </p>

      {/* Resim ve Bilgiler */}
      <div className="mt-8 flex flex-col md:flex-row items-center md:space-x-8">
        {/* Profil Resmi */}
        <img
          src="/images/profile.jpg"
          alt="Profil Resmi"
          className="w-40 h-40 md:w-56 md:h-56 rounded-full shadow-lg"
        />

        {/* Bilgiler */}
        <div className="mt-6 md:mt-0 text-center md:text-left">
          <h2 className="text-2xl font-semibold">İlgi Alanlarım</h2>
          <ul >
            <li>Web ve Mobil Geliştirme</li>
            <li>Yapay Zeka ve Görüntü İşleme</li>
            <li>Otomotiv & Savunma Sanayii</li>
          </ul>
        </div>
      </div>

      {/* İletişim Butonu */}
      <a
        href="mailto:example@email.com"
        className="mt-8 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-6 rounded"
      >
        Bana Ulaş
      </a>
    </div>
  );
};

export default AboutPage;
